import type { ReactNode } from 'react';
import { AlertCircle, AlertTriangle, CheckCircle } from 'lucide-react';

import { Tooltip } from '@/components/ui/tooltip';

import { KnownComplianceStatus } from '../entities/compliance-status';

type ComplianceStatusIconProps = {
  // INFO: for the moment there is only icon for known statuses
  status: KnownComplianceStatus;
};

const iconFromStatus: Record<KnownComplianceStatus, ReactNode> = {
  [KnownComplianceStatus.NO_DATA]: <AlertCircle className="size-4" />,
  [KnownComplianceStatus.COMPLIANT]: <CheckCircle className="size-4" />,
  [KnownComplianceStatus.NON_COMPLIANT]: <AlertTriangle className="size-4" />,
  [KnownComplianceStatus.AT_RISK]: <AlertCircle className="size-4" />,
};

export const tooltipFromStatus: Record<KnownComplianceStatus, string> = {
  [KnownComplianceStatus.NO_DATA]: 'No Data',
  [KnownComplianceStatus.COMPLIANT]: 'Compliant',
  [KnownComplianceStatus.NON_COMPLIANT]: 'Non-compliant',
  [KnownComplianceStatus.AT_RISK]:
    'Currently compliant, but trending toward violation',
};

export function ComplianceStatusIcon({ status }: ComplianceStatusIconProps) {
  return (
    <Tooltip delay content={tooltipFromStatus[status]}>
      {iconFromStatus[status]}
    </Tooltip>
  );
}
